import createIcon from '../../createIcon';

/**
 * @component @name Notes
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxOEgxNVYxNkgzVjE4Wk0zIDZWOEgyMVY2SDNaTTMgMTNIMjFWMTFIM1YxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Notes = createIcon('Notes', [
  ['path', { d: 'M3 18H15V16H3V18ZM3 6V8H21V6H3ZM3 13H21V11H3V13Z', key: '3r9sko' }],
]);

export default Notes;
